module.exports = __webpack_public_path__ + "img/inspiring_background_parallax.dd9a682.jpg";